import React from 'react';

const TIP_ACTIONS = {
  ef:   { label: 'Log savings →',     tab: 'money' },
  apr:  { label: 'See payoff plan →', tab: 'progress' },
  sav:  { label: 'Log savings →',     tab: 'money' },
  aval: { label: 'Switch strategy →', tab: 'progress' },
  lump: { label: 'Try lump sum →',    tab: 'progress' },
};

export function FinancialTipsCard({ tips, setTab }) {
  if (!tips.length) return null;

  return (
    <div className="card cp" style={{ marginBottom: 12 }}>
      <div className="st">📚 Financial Tips</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {tips.map((tip) => {
          const action = TIP_ACTIONS[tip.id];
          return (
            <div
              key={tip.id}
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                padding: '11px 13px',
                background: 'var(--surf2)',
                borderRadius: 10,
                border: '1px solid var(--bdr)',
                borderLeft: '3px solid ' + tip.color,
              }}
            >
              <div style={{ display: 'flex', gap: 12 }}>
                <span style={{ fontSize: 20, flexShrink: 0 }}>{tip.em}</span>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 4, color: tip.color }}>
                    {tip.title}
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--mut)', lineHeight: 1.6 }}>{tip.body}</div>
                </div>
              </div>
              {action && setTab && (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <button
                    onClick={() => setTab(action.tab)}
                    style={{
                      padding: '5px 12px',
                      borderRadius: 8,
                      border: '1px solid ' + tip.color,
                      background: 'transparent',
                      color: tip.color,
                      fontSize: 11,
                      fontWeight: 700,
                      cursor: 'pointer',
                      fontFamily: 'inherit',
                    }}
                  >
                    {action.label}
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
